import React from 'react';
import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import "react-datepicker/dist/react-datepicker.css";
import {Content} from "../../../components/Content";
import {HBox} from "../../../components/Box";
import {Circle} from "../../../components/Icon";
import {Button} from "../../../components/Buttons";
import {
  createWebhookSubscription, deleteWebhookSubscription,
  getExactAuthInitialLink,
  getExactAuthStatus,
  getExactWebhookSubscriptions
} from "../../Invoices/actions";
import {
  selectExactAuthInitialLink,
  selectExactAuthStatus,
  selectInvoice,
  selectWebhooksList
} from "../../Invoices/selectors";
import {selectWork} from "../../Api/selectors";
import {
  REQUEST_EXACT_AUTH_LINK,
  REQUEST_EXACT_AUTH_STATUS,
  REQUEST_EXACT_WEBHOOK_SUBSCRIPTIONS,
  REQUEST_INVOICE
} from "../../Invoices/constants";
import {Loader} from "../../../components/Loader";
import { Checkbox } from "../../../components/Checkbox";
import { Sort } from "../../../components/Sort";
import { KanbanProgressBar } from "../../KanbanBoards/components/ProgressBar";
import { UserLabelById } from "../../Users/components/UserLabelById";
import { CompanyStatusCard } from "../../Companies/components/StatusLabel";
import { ViesLabel } from "../../Companies/components/ViesLabel";

const Container = styled.div``;

const LoggedIn = styled.div`
  color: green;
`;

const LoggedOut = styled.div`
  color: red;
`;

const LoginBtn = styled.div`
  width: 30%;
`;

const WebhooksSection = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`;

const STATE = {
}

/* eslint-disable react/prefer-stateless-function */
class ExactIntegrationSettingsComp extends BaseComponent {
    constructor(props) {
        super(props, STATE);
    }

  componentDidMount() {
    this.props.getExactAuthStatus();
    this.props.getExactAuthInitialLink();
    this.props.getWebhooksList();
  }

    get status() {
      return (
        this.props.exactAuthStatus ?
        <LoggedIn>
          <Circle />
        </LoggedIn> :
        <LoggedOut>
          <Circle />
        </LoggedOut>
      );
    }

    get webhooks() {
      const fetched = this.props.webhooks ?? [];
      const webhooks = [
        { topic: 'TransactionLines' },
      ];

      for (let webhook of webhooks) {
        const found = fetched.find(f => f.topic === webhook.topic) ?? null;
        webhook.status = found ? 1 : 0;
        webhook.callback = found ? found.callback : '';
        webhook.id = found ? found.id : null;
      }

      return webhooks;
    }

    renderWebhooksSection() {
      if (!this.props.exactAuthStatus) return '';

      return (
        <WebhooksSection>
              <HBox vCenter left>
                <h3>{this.lbl('tools.overview.Webhooks')}</h3>
              </HBox>
            {this.webhooks.filter(i => i).map(i => this.renderWebhookRow(i))}
        </WebhooksSection>
      );
    }

  renderWebhookRow(item) {
    return (
      <HBox
        vCenter
        left
        key={item.topic}
        id={`item${item.topic}`}
      >
        {['action', 'topic', 'status', 'callback'].map(col => this.renderWebhookCell(col, item))}
      </HBox>
    );
  }

  onClickSubscribeWebhook(topic) {
      this.props.addWebhookSubscriptions(topic);
  }

  onClickDeleteWebhookSubscription(id) {
      this.props.deleteWebhookSubscriptions(id);
  }

  renderWebhookCell(col, item) {
    const fn = () => {
      switch (col) {
        case 'topic':
          if (!item.topic) return '';
          return item.topic;
        case 'callback':
          if (!item.topic) return '';
          return item.callback;
        case 'status':
          return item.status ?
            (<LoggedIn>
              <Circle/>
            </LoggedIn>) :
            (<LoggedOut>
              <Circle/>
            </LoggedOut>);
        case 'action':
          return !item.id ?
            (<Button
              onClick={event => this.onClickSubscribeWebhook(item.topic)}
            >
              Activate
            </Button>) :
            (<Button
              onClick={event => this.onClickDeleteWebhookSubscription(item.id)}
            >
              Stop
            </Button>);
      }
    }

    return (
      <div className={`item-cell col-${col}`} key={`${col}-${item.id}`}>
        {fn()}
      </div>
    );
  }

    render() {
      if (this.props.work) return <Loader small />;
      return (
          <Container>
            <h3>{this.lbl('tools.overview.exactLabel')}</h3>
            <Content>
              <HBox left vCenter>
                <p>{this.lbl('tools.overview.loggedInLabel')}</p>
                {this.status}
              </HBox>
              <LoginBtn>
                <Button onClick={() => window.open(this.props.exactAuthInitialLink)}>{this.lbl('tools.overview.exactLoginBtn')}</Button>
              </LoginBtn>
              <p>{this.lbl('tools.overview.exactTip')}</p>
            </Content>
            {this.renderWebhooksSection()}
          </Container>
      );
    }
}

ExactIntegrationSettingsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork([REQUEST_EXACT_AUTH_STATUS, REQUEST_EXACT_AUTH_LINK, REQUEST_EXACT_WEBHOOK_SUBSCRIPTIONS]),
    exactAuthStatus: selectExactAuthStatus(),
    exactAuthInitialLink: selectExactAuthInitialLink(),
    webhooks: selectWebhooksList(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    getExactAuthStatus(callback) {
      dispatch(getExactAuthStatus(callback));
    },
    getExactAuthInitialLink(callback) {
      dispatch(getExactAuthInitialLink(callback));
    },
    getWebhooksList() {
      dispatch(getExactWebhookSubscriptions());
    },
    addWebhookSubscriptions(topic) {
      dispatch(createWebhookSubscription({topic}));
    },
    deleteWebhookSubscriptions(id) {
      dispatch(deleteWebhookSubscription(id));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const ExactIntegrationSettings = compose(
  withConnect,
  withRouter,
)(ExactIntegrationSettingsComp);
